/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_PurchaseInputs */

const cs_enum_purchase = /** @type {(inputs: Enum_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koupě`)
};

const en_enum_purchase = /** @type {(inputs: Enum_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase`)
};

/**
* | output |
* | --- |
* | "Purchase" |
*
* @param {Enum_PurchaseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_purchase = /** @type {((inputs?: Enum_PurchaseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_PurchaseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_purchase(inputs)
	return cs_enum_purchase(inputs)
});